export default "__VITE_ASSET__BvBFiv$P__"